import type { RoomDuty } from "../../shared/api/workShifts";

/**
 * #19943 — bác sĩ được mời ở ô Bác sĩ khi đã chọn phòng.
 *
 * - Phòng có bác sĩ trực lúc đó → chỉ những bác sĩ đang trực phòng đó.
 * - Phòng không có ai trực (chưa có lịch trực, hoặc có lịch nhưng không ai trực giờ đó) → mọi bác sĩ
 *   trừ những người đang trực MỘT PHÒNG KHÁC lúc đó.
 * - Bác sĩ điền sẵn (`autoDoctorId`, đúng người tầng ghi gán khi không chọn) luôn có trong danh sách,
 *   kể cả khi là bác sĩ mặc định của phòng mà đang trực phòng khác — nếu không ô sẽ hiện một giá
 *   trị không có trong danh sách.
 *
 * Chưa chọn phòng, hoặc chưa có câu trả lời về lịch trực → giữ nguyên danh sách.
 */
export function eligibleRoomDoctors<T extends { id: string }>(
  doctors: readonly T[],
  roomId: string | null | undefined,
  duty: RoomDuty | undefined
): T[] {
  if (!roomId || !duty) return [...doctors];
  const auto = duty.autoDoctorId;
  if (duty.doctorIds.length > 0) {
    const onDuty = new Set(duty.doctorIds);
    return doctors.filter((d) => onDuty.has(d.id) || d.id === auto);
  }
  const busy = new Set(duty.busyElsewhereDoctorIds ?? []);
  return doctors.filter((d) => !busy.has(d.id) || d.id === auto);
}
